import React from 'react';
import { useSearchParams } from 'react-router-dom';

export const withSearchParams = (Component: any) => {
  function ComponentWithSearchParamsProps(props: any) {
    const [searchParams, setSearchParams] = useSearchParams();

    return (
      <Component
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        {...props}
      />
    );
  }

  return ComponentWithSearchParamsProps;
};
